export class LoggerService {
	public static log(message: string) {
		console.log(message);
	}

	public static error(error: Error | string | unknown) {
		console.error(error);
	}
}
